var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetails({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83335 1.3335H4.50002C4.1464 1.3335 3.80726 1.47397 3.55721 1.72402C3.30716 1.97407 3.16669 2.31321 3.16669 2.66683V13.3335C3.16669 13.6871 3.30716 14.0263 3.55721 14.2763C3.80726 14.5264 4.1464 14.6668 4.50002 14.6668H12.5C12.8536 14.6668 13.1928 14.5264 13.4428 14.2763C13.6929 14.0263 13.8334 13.6871 13.8334 13.3335V5.3335L9.83335 1.3335Z",
    stroke: "#002D5D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83331 1.3335V5.3335H13.8333",
    stroke: "#002D5D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1666 8.66699H5.83331",
    stroke: "#002D5D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1666 11.3335H5.83331",
    stroke: "#002D5D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16665 6H6.49998H5.83331",
    stroke: "#002D5D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/details.0a8e408be4e13f3dbb34328498db2cab.svg";
export { ForwardRef as ReactComponent };